<template>
	<inertia-head title="Bo Sanchez FREE Ebook - Seven Success Principles" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Success Principles
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Discover the Seven Success Principles from the Ancient Book of Proverbs for Your Money, Work and Life
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				<h2 class="text-center">Put Your Name and Email Below To Get Your FREE ebook</h2>
				<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="form-group mb-3">
							<label>First Name</label>
							<input type="text" v-model="form.fname" name="fname" class="form-control" :class="{ 'is-invalid': form.errors.fname }" />
							<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
						</div>
						<div class="form-group mb-3">
							<label>Last Name</label>
							<input type="text" v-model="form.lname" name="lname" class="form-control" :class="{ 'is-invalid': form.errors.lname }"/>
							<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
						</div>
						<div class="form-group mb-3">
							<label>Email Address</label>
							<input type="text" v-model="form.email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.email }"/>
							<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
						</div>
						<div class="form-group mt-4">
							<label>Mobile</label>
							<vue-tel-input
								@input="onInput"
								@countryChanged="onCountryChange"
								v-model="form.mobile"
								:value="form.mobile"
								class="form-control"
								:class="{ 'is-invalid': form.errors.mobile }"
								:input-options="{
									placeholder: 'Enter mobile number',
								}"
								:defaultCountry="form.country_code"
								mode="international"
							/>
							<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
						</div>
						<div class="form-group mt-4 text-center">
							<button @click="claimBook" type="button" class="btn btn-success">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-envelope me-1"></i>Send My FREE E-Book!
							</button>
						</div>
					</div>
				</div>
				<div class="block-content block-content-full">
					<p class="text-center">Your referring affiliate is: {{affiliate_name}}</p>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
			affiliate 		: String,
			affiliate_name 	: String,
		},
		setup(props){

			const form = useForm({
				fname 		: '',
				lname 		: '',
				email 		: '',
				affiliate 	: props.affiliate,
				country_calling_code: '63',
				country_code: '',
				mobile		: ''
			})

			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}

				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}

			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2;
			}

			const claimBook = ()=>{
				form.post(route("post.success-principles"),{
					preserveState: true,
					preserveScroll: true,
					only:['flash','errors','affiliate','affiliate_name'],
					onSuccess:()=>{
						form.reset();
					}
				});
			}

			return {
				form,
				onInput,
				onCountryChange,
				claimBook
			}

		}
	}
</script>